export const SIGN_IN_WITH_PASSWORD_BUTTON_TEXT = {
  'sign_in_with_password.button': {
    'en-GB': 'Sign in with your password',
    'nl-NL': 'Log in met je wachtwoord',
  },
}
